import { makeStyles } from '@material-ui/core';

import {
  MAIN_LAYOUT_FOOTER_HEIGHT,
  MAIN_LAYOUT_HEADER_HEIGHT,
} from 'shared/styles/constants';
import { neutral } from 'shared/styles/colors';

export default makeStyles(theme => ({
  customMoreVertButton: { marginLeft: 'auto' },
  root: {
    marginTop: MAIN_LAYOUT_HEADER_HEIGHT,
    marginBottom: MAIN_LAYOUT_FOOTER_HEIGHT,
  },
  backdrop: {
    marginTop: MAIN_LAYOUT_HEADER_HEIGHT,
    marginBottom: MAIN_LAYOUT_FOOTER_HEIGHT,
  },
  paper: {
    position: 'relative',
    padding: '0.75rem 1rem 1rem 1rem',
    boxShadow: 'none',
    '@media print': {
      display: 'none',
    },
    [theme.breakpoints.up('md')]: {
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      height: '100vh',
      width: '100%',
      maxWidth: '67.5rem',
      padding: '0.75rem 1rem 1.5rem 1.5rem',
      overflowY: 'hidden',
      '@media print': {
        display: 'none',
      },
    },
  },
  title: {
    fontFamily: 'PP Object Sans',
    fontWeight: 700,
    lineHeight: '2rem',
    color: neutral[100],
    padding: 0,
  },
  headerRoot: {
    border: 'none',
  },
}));
